<template>
  <v-container
    class="change_password all-center"
    style="width: 100%; margin-bottom: 100px;"
  >
    <v-card width="500">
      <div class="pa-5">
        <h2>{{ $i18n.t("personal.change_password") }}</h2>
      </div>
      <v-form v-model="valid" class="px-4 py-2">
        <v-text-field
          v-model="oldPassword"
          prepend-inner-icon="mdi-email"
          name="oldPassword"
          :label="$i18n.t('login.Original password')"
          :type="isShowPassword0 ? 'text' : 'password'"
          required
          :rules="[required, counter]"
          outlined
        >
          <v-fade-transition slot="append" mode="out-in">
            <v-icon
              :key="`icon-${isShowPassword}`"
              @click="isShowPassword0 = !isShowPassword0"
              v-text="isShowPassword0 ? 'mdi-eye' : 'mdi-eye-off'"
            />
          </v-fade-transition>
        </v-text-field>
        <v-text-field
          id="password"
          v-model="newPassword"
          prepend-inner-icon="mdi-lock"
          name="newPassword"
          :label="$i18n.t('login.new password')"
          :rules="[required, counter]"
          required
          :type="isShowPassword ? 'text' : 'password'"
          outlined
        >
          <v-fade-transition slot="append" mode="out-in">
            <v-icon
              :key="`icon-${isShowPassword}`"
              @click="isShowPassword = !isShowPassword"
              v-text="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
            />
          </v-fade-transition>
        </v-text-field>

        <v-text-field
          v-model.trim="newPasswordR"
          :label="$i18n.t('login.confirm_password')"
          prepend-inner-icon="mdi-lock"
          :type="isShowPassword2 ? 'text' : 'password'"
          :rules="[required, counter]"
          :error="newPassword !== newPasswordR"
          :error-messages="
            newPassword !== newPasswordR
              ? $i18n.t('login.confirm_password')
              : ''
          "
          outlined
        >
          <v-fade-transition slot="append" mode="out-in">
            <v-icon
              :key="`icon-${isShowPassword}`"
              @click="isShowPassword2 = !isShowPassword2"
              v-text="isShowPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
            />
          </v-fade-transition>
        </v-text-field>
        <v-btn
          style="width: 100%;"
          color="#3f57bb"
          @click="changePwd"
          :disabled="!valid"
          class="common-button white--text"
        >
          {{ $i18n.t("login.confirm the modification") }}
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ChangePassword",
  data() {
    return {
      valid: false,
      oldPassword: "",
      newPassword: "",
      newPasswordR: "",
      isShowPassword0: false,
      isShowPassword: false,
      isShowPassword2: false,
      verifyFail: false,
    };
  },
  methods: {
    ...mapActions(["resetPwd"]),
    changePwd() {
      this.resetPwd({
        password: this.$md5(this.oldPassword),
        newPassword: this.$md5(this.newPassword),
      }).then((res) => {
        if (res.data.code === 200) {
          this.$router.push("/");
        }
      });
    },
    required(value) {
      return !!value || this.$i18n.t("login.What is required");
    },
    email(value) {
      const pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      return (
        pattern.test(value) ||
        this.$i18n.t("login.Please enter the correct mailbox")
      );
    },
    counter(value) {
      return (
        value.length >= 8 ||
        this.$i18n.t("login.Cannot be less than 8 characters")
      );
    },
  },
};
</script>

<style scoped></style>
